// Ruoli che un utente può avere, sulla base di questi ruoli verranno mostrate le pagine e le funzionalità disponibili
export enum ERoles {
    User = 'USER',
    Technician = 'TECHNICIAN',
    Service = 'SERVICE',
    Subsidiary = 'SUBSIDIARY',
    Admin = 'ADMIN',
    Marketing = 'MARKETING',
    FirmTech = 'FIRM_TECH'
}

export interface Role {
    Id: number;
    Description: string;
}

export interface RoleExplained {
    isUser?: boolean;
    isTechnician?: boolean;
    isService?: boolean;
    isAdmin?: boolean;
    isMarketing?: boolean;
    isSubsidiary?: boolean;
    isFirmTech?: boolean;
}
